import axios from "axios";
import { db } from "./firebase/client";
import { doc, getDoc, setDoc } from "firebase/firestore";

export const authenticate = async () => {
  const jwt = await axios({
    method: "get",
    url: "https://gateway.mipaymentchoice.com/api/authenticate",
    params: {
      Username: "mi3c9642",
      Password: "a0773ef6b7b3440d",
      format: "json",
    }
  });
  return jwt.data.BearerToken;
};

export const runTransaction = async (body) => {
  const { CardData, InvoiceData, token } = body;

  try {
    const response = await axios({
      method: "post",
      url: "https://gateway.mipaymentchoice.com/api/v2/transactions/bcp",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        TransactionType: "Sale",
        ForceDuplicate: true,
        CardData: CardData,
        InvoiceData: InvoiceData,
        format: "json"
      }
    });
    return response;
   } catch (err) {
    console.log('Error with running transaction: ', err);
   }
}

export const createCustomer = async (body) => {
  const { customerInformation, token, address } = body;
  try {
    const response = await axios({
      method: "post",
      url: "https://gateway.mipaymentchoice.com/api/customers",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        CustomerName: customerInformation.name,
        CustomerId: customerInformation.name,
        BillingAddress: address,
        DefaultContact: {
          MobileTelephoneNumber: customerInformation.phoneNumber,
          EmailAddress: customerInformation.email
        },
        ActivationStatus: "Active"
      },
      params: {
        format: "json"
      }
    });
    return response;
  } catch (err) {
    console.log('Error with creating customer: ', err);
  }
}

export const createRecurringPayment = async (body) => {
  const { merchantKey, customerKey, authToken, token, startDate, endDate, amount } = body;
  /*
    Not sure how to obtain merchantKey, seems to be from creating a customer?
  */
 try {
  const firebaseSnap = await getDoc(doc(db, "id", "id"));
  const firebaseData = firebaseSnap.data();
  const firebaseId = firebaseData.id;
  const updateOperation = await setDoc(doc(db, "id", "id"), { id: firebaseId + 1 });
  const response = await axios({
    method: "post",
    url: `https://gateway.mipaymentchoice.com/api/merchants/${merchantKey}/customers/${customerKey}/contracts`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    data: {
      StartDate: startDate,
      EndDate: endDate,
      Token: token,
      BillingPeriod: "MONTH",
      ActivationStatus: "Active",
      FailurePeriod: "WEEK",
      EmailCustomerReceiptOption: "OnApproval",
      MerchantContractName: "Mi3 Connect Monthly",
      MerchantContractId: firebaseId,
      BillAmount: amount,
      MerchantKey: merchantKey,
      CustomerKey: customerKey
    },
    params: {
      format: 'json'
    }
  });
  return response;
 } catch (err) {
  console.log('Error with creating recurring payment: ', err);
 }
};

export const createCard = async (body) => {
  const { authToken, customerKey, cardNumber, expirationDate } = body;
  try {
    const response = await axios({
      method: "post",
      url: `https://gateway.mipaymentchoice.com/api/merchants/205/tokens/cards`,
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        CustomerKey: customerKey,
        CardNumber: cardNumber,
        ExpirationDate: expirationDate
      },
      params: {
        format: 'json'
      }
    });
    return response;
  } catch (err) {
    console.log('Error with creating card: ', err);
  }
};

export const stateNameToCode = (stateName) => {
  const stateCodes = {
    "ALABAMA": "AL",
    "ALASKA": "AK",
    "ARIZONA": "AZ",
    "ARKANSAS": "AR",
    "CALIFORNIA": "CA",
    "COLORADO": "CO",
    "CONNECTICUT": "CT",
    "DELAWARE": "DE",
    "FLORIDA": "FL",
    "GEORGIA": "GA",
    "HAWAII": "HI",
    "IDAHO": "ID",
    "ILLINOIS": "IL",
    "INDIANA": "IN",
    "IOWA": "IA",
    "KANSAS": "KS",
    "KENTUCKY": "KY",
    "LOUISIANA": "LA",
    "MAINE": "ME",
    "MARYLAND": "MD",
    "MASSACHUSETTS": "MA",
    "MICHIGAN": "MI",
    "MINNESOTA": "MN",
    "MISSISSIPPI": "MS",
    "MISSOURI": "MO",
    "MONTANA": "MT",
    "NEBRASKA": "NE",
    "NEVADA": "NV",
    "NEW HAMPSHIRE": "NH",
    "NEW JERSEY": "NJ",
    "NEW MEXICO": "NM",
    "NEW YORK": "NY",
    "NORTH CAROLINA": "NC",
    "NORTH DAKOTA": "ND",
    "OHIO": "OH",
    "OKLAHOMA": "OK",
    "OREGON": "OR",
    "PENNSYLVANIA": "PA",
    "RHODE ISLAND": "RI",
    "SOUTH CAROLINA": "SC",
    "SOUTH DAKOTA": "SD",
    "TENNESSEE": "TN",
    "TEXAS": "TX",
    "UTAH": "UT",
    "VERMONT": "VT",
    "VIRGINIA": "VA",
    "WASHINGTON": "WA",
    "WEST VIRGINIA": "WV",
    "WISCONSIN": "WI",
    "WYOMING": "WY",
};

const stateNameFormatted = stateName.trim().toUpperCase();
  const stateCode = stateCodes[stateNameFormatted] || "Unknown";

  return stateCode;
}
